(ns entities.brand.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::hex-color (s/and string? #(clojure.string/starts-with? % "#")))

(s/def ::disclosure string?)
(s/def ::logo string?)
(s/def ::name string?)

(s/def ::primary-color ::hex-color)
(s/def ::secondary-color ::hex-color)
(s/def ::tertiary-color ::hex-color)

(s/def ::brand (s/keys :req-un [::disclosure
                                ::logo
                                ::name
                                ::primary-color
                                ::secondary-color
                                ::tertiary-color]))


(s/def ::domain string?)
(s/def ::get (s/keys :req-un [::domain]))
